import { Worker } from "src/types"
import { doFetch } from "./fetch"

export const usersApi = {
  getUsers: () => {
    return doFetch(`/api/tenants/users`)
  },

  getWorkers: () => {
    return doFetch(`/api/views/workers`)
  },

  updateUser: (
    id: number,
    body: Partial<
      Pick<
        Worker,
        "name" | "username" | "email" | "coeficient" | "permissions" | "role"
      >
    >
  ) => {
    return doFetch(`/api/tenants/users/${id}`, { body, method: "PUT" })
  },

  deleteUser: (id: number) => {
    return doFetch(`/api/tenants/users/${id}`, { method: "DELETE" })
  },

  resetUserPasswordUrl: (id: number, force?: boolean) => {
    return doFetch(`/api/tenants/users/${id}/reset`, {
      body: {
        force: force ?? false,
      },
      method: "POST",
    })
  },
  getAvailableWorkers: (query?: string) => {
    return doFetch(`/api/tenants/workers?${query ?? ''}`)
  },
}
